import React from 'react';

function LuversUnit(props:any) {
    return (
      <div style={props.hideStyle} className="Luvers-unit">
        <div className={`oczka-${props.unit}`}></div>
      </div>
    );
  }
  
  export default LuversUnit;
